import React, { useCallback, useEffect, useState } from 'react';
import * as Styles from './OtherToolsSuccess.styles';
import { IconArrow, IconCircleCheck, Radio } from 'gatorcomponents';
import OtherToolsBr from '@/media/onboarding/otherTools/other_tools_br.png';
import OtherToolsEs from '@/media/onboarding/otherTools/other_tools_es.png';
import { OTHER_TOOLS_OPTION_IDS } from './OtherToolsSuccess.enum';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';
import { isBRServer } from '@/utils/Validators/validation';
import { onboardingAnalytics } from '@/analytics/onboarding';

const OtherToolsSuccess = ({
  title,
  description,
  options,
  redirectToCpanel,
  loadingCpanelSSOProduct,
  redirectToFtp,
  rightButtonLabel,
  leftButtonLabel,
  onBackToStart,
  redirectToDomainFeedback,
  dnsChanged,
  isInternalDomain,
  usingTempDomain,
  setSelectedOtherOption,
}) => {
  const [checkedOption, setCheckedOption] = useState({});

  const callAnalyticsWhenCheckOption = useCallback(() => {
    const analyticsRules = {
      [OTHER_TOOLS_OPTION_IDS.CPANEL]: onboardingAnalytics.otherTools.cpanelCta,
      [OTHER_TOOLS_OPTION_IDS.SOFTACULOUS]: onboardingAnalytics.otherTools.softaculousCta,
      [OTHER_TOOLS_OPTION_IDS.FTP]: onboardingAnalytics.otherTools.ftpCta,
    };

    const analyticsFunction = checkedOption && analyticsRules[checkedOption.id];
    analyticsFunction && analyticsFunction();
  }, [checkedOption]);

  useEffect(() => {
    callAnalyticsWhenCheckOption();
  }, [callAnalyticsWhenCheckOption]);

  const handleRedirect = () => {
    const rules = {
      [OTHER_TOOLS_OPTION_IDS.CPANEL]: () => redirectToCpanel({ softaculous: false }),
      [OTHER_TOOLS_OPTION_IDS.SOFTACULOUS]: () => redirectToCpanel({ softaculous: true }),
      [OTHER_TOOLS_OPTION_IDS.FTP]: () => redirectToFtp(),
    };

    if ((!isInternalDomain || dnsChanged) && !usingTempDomain) {
      return redirectToDomainFeedback({ redirectFunc: rules[checkedOption.id] });
    }

    return rules[checkedOption.id]();
  };

  const handleBackToStart = () => {
    onBackToStart && onBackToStart();
  };

  const buttonsProps = {
    leftButton: {
      testId: 'leftButton',
      onClick: handleBackToStart,
      label: leftButtonLabel,
    },
    rightButton: {
      testId: 'rightButton',
      loading: loadingCpanelSSOProduct,
      iconRight: <IconArrow direction="right" />,
      disabled: loadingCpanelSSOProduct || !checkedOption.id,
      onClick: handleRedirect,
      label: rightButtonLabel,
    },
  };

  const handleSelectOption = (option) => {
    setSelectedOtherOption(option.id);
    setCheckedOption(option);
  };

  return (
    <GenericStep
      imageSrc={isBRServer ? OtherToolsBr : OtherToolsEs}
      buttonsProps={buttonsProps}
    >
      <Styles.Wrapper>
        <Styles.TitleContainer>
          <IconCircleCheck color="primaryMedium" size="lg" />
          <Styles.Title>
            {title}
          </Styles.Title>
        </Styles.TitleContainer>

        <Styles.Subtitle>{description}</Styles.Subtitle>

        <Styles.OptionsWrapper>
          {options.map(option => (
            <Styles.ListItem key={option.id}>
              <Styles.RadioLabel
                data-testid={`option-${option.id}`}
                htmlFor={option.id}
                onClick={() => handleSelectOption(option)}
                role="button"
                $checked={checkedOption.id === option.id}
              >
                <Styles.OptionRow>
                  <Radio id={option.id} variant="blue" checked={checkedOption.id === option.id} />
                  <Styles.OptionTitle>
                    {option.title}
                  </Styles.OptionTitle>
                </Styles.OptionRow>

                <Styles.OptionRow>
                  <Styles.OptionDescription>
                    {option.description}
                  </Styles.OptionDescription>
                </Styles.OptionRow>
              </Styles.RadioLabel>
            </Styles.ListItem>
          ))}
        </Styles.OptionsWrapper>
      </Styles.Wrapper>
    </GenericStep>
  );
};

export default OtherToolsSuccess;
